import { Button } from "antd";
import type { Dayjs } from "dayjs";
import { DownloadOutlined } from "@ant-design/icons";
import { ChevronDown, ChevronUp, Filter } from "react-feather";

import CustomDatePicker from "../CommonComponents/CustomDatePicker/CustomDatePicker";
import { AppStrings } from "../../utils/constants/AppStrings";

export interface ReportingSummaryHeaderProps {
  reportingDates: [Dayjs, Dayjs];
  setReportingDates: (dates: [Dayjs, Dayjs]) => void;
  onReportingRangeQuery: (queryString?: string | null) => void;
  startRange: string;
  onTableDownload: () => void;
  showFilters?: boolean;
  onToggleFilters?: () => void;
}

function ReportingSummaryHeader({
  reportingDates,
  setReportingDates,
  onReportingRangeQuery,
  startRange,
  onTableDownload,
  showFilters = false,
  onToggleFilters,
}: ReportingSummaryHeaderProps) {
  return (
    <>
      <div className="reporting-summary-header">
        <div
          className="reporting-summary-header-actions"
          data-testid="reporting-summary-header-actions"
        >
          {onToggleFilters ? (
            <button
              type="button"
              className="reporting-summary-filter-toggle"
              data-testid="reporting-summary-filter-toggle"
              aria-label={AppStrings.REPORTING_FILTERS_TOGGLE_ARIA}
              aria-expanded={showFilters}
              onClick={onToggleFilters}
            >
              <Filter size={18} />
              {showFilters ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </button>
          ) : null}
          <div
            className="reporting-summary-date-picker"
            data-testid="reporting-summary-date-picker"
          >
            <CustomDatePicker
              dates={reportingDates}
              setDates={setReportingDates}
              getData={onReportingRangeQuery}
              showPresets
              startRange={startRange}
            />
          </div>
          <Button
            type="default"
            className="reporting-summary-download"
            icon={<DownloadOutlined />}
            aria-label="Download"
            onClick={onTableDownload}
          />
        </div>
      </div>
    </>
  );
}

export default ReportingSummaryHeader;
